import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=33f20d4a&"
import script from "./LoginLayout.vue?vue&type=script&lang=js&"
export * from "./LoginLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f20d4a')) {
      api.createRecord('33f20d4a', component.options)
    } else {
      api.reload('33f20d4a', component.options)
    }
    module.hot.accept("./LoginLayout.vue?vue&type=template&id=33f20d4a&", function () {
      api.rerender('33f20d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/views/LoginLayout.vue"
export default component.exports